/*
 * All Insights need to defined defined in this file so they can be loaded
 * dynamically based on user configuration.
 */
// import { lazy } from 'react'

import { ReeferAlarmDetails } from './alarm/details'
import { ReeferAlarmsActive } from './alarm/reeferAlarmsActive'
import { ReeferAlarmsDetail } from './alarm/reeferAlarmsDetail'
import { ReeferAlarmCountByAlarmName } from './alarm/reeferCountByAlarmName'
import { ReeferAlarmCountByAsset } from './alarm/reeferCountByAsset'
import { ReeferAlarmCountByReeferMake } from './alarm/reeferCountByReeferMake'
import { ReeferAlarmCountBySeverity } from './alarm/reeferCountBySeverity'
import { AlertAcknowledgementDetail } from './alert/alertAcknowledgementDetail'
import { AlertAcknowledgementSummary } from './alert/alertAcknowledgementSummary'
import { AlertsActive } from './alert/alertActive'
import { AlertsDetail } from './alert/alertsDetail'
import { AlertCountByAlertName } from './alert/countByAlertName'
// import { AssetList } from './assets'
// import DemoTable from './demo/table/DemoTable'
import { AlertCountByAsset } from './alert/countByAsset'
import { AlertCountBySeverity } from './alert/countBySeverity'
import { InstoreAlertDetail } from './alert/instoreAlertDetail'
import {
  AlertAcknowledgementByAsset,
  AssetTimeline,
  DoorActivities,
  HistoryGraph,
  InStoreHistoryGraph,
  ReeferControlHistory,
  ReeferOperationHistory,
  ReeferOperationDetail,
  ReeferHistory,
  ReeferFridgeDataHistory,
  LocationHistory,
  RouteHistoryMap,
  AssetFleetCheck,
  MonitoringPointTemperature,
  CurrentEngineHours,
  BatteryVoltage,
  ReeferRunTimeByAsset,
} from './assets'
import { FuelHistory } from './fuel/fuelHistory'
import { ReeferFuel } from './fuel/reeferFuel'
import { ReeferFuelGraph } from './fuel/reeferFuelGraph'
import {
  DoorEventsSummary,
  InstoreDoorEventsSummary,
  MonitoringPointHumidity,
  MonitoringPointTemperature as MonitoringPointTemperatureReport,
  SpeedException,
  TripActivity,
  TripReeferSummary,
} from './reports'
import { ReeferSpeedGraph } from './speed/reeferSpeedGraph'
// import { DoorOpenedOutsideGeofenceCount } from './door/openedOutsideGeofenceCount'
// import { DoorOpenedOutsideGeofenceDetail } from './door/openedOutsideGeofenceDetail'
// import { AverageMonitoringPointTemperature } from './temperature/averageMonitoringPoint'
import { TemperatureHistory } from './temperature/history'
import { InStoreTemperatureHistory } from './temperature/inStoreHistory'
import { StationaryAssetCount } from './utilization/stationaryAssetCount'
import { StationaryAssetsDetail } from './utilization/stationaryAssetsDetail'

export const categories = {
  alert: {
    name: 'Alerts',
    description: 'Insights related to alerts',
  },
  asset: {
    name: 'Assets',
    description: 'Insights related to assets',
  },
  fuel: {
    name: 'Fuel',
    description: 'Insights related to fuel',
  },
  /*
  door: {
    name: 'Door',
    description: 'Insights related to doors',
  },
  */
  reeferAlarm: {
    name: 'Reefer Alarms',
    description: 'Insights related to alarms',
  },
  speed: {
    name: 'Speed',
    description: 'Insights related to reefer speed',
  },
  temperature: {
    name: 'Temperature',
    description: 'Insights related to temperature',
  },
  utilization: {
    name: 'Utilization',
    description: 'Insights related to asset utilization',
  },
  report: {
    name: 'Reports',
    description: 'Operational reports',
  },
  /*
  usage: {
    name: 'Usage',
    description: 'Insights related to asset usage',
  },
  demo: {
    name: 'Demo',
    description: 'Sample Insights for demonstration purposes',
  },
  */
}

export const insights = {
  'alarm/alarms-active': ReeferAlarmsActive,
  'alarm/alarms-detail': ReeferAlarmsDetail,
  'alarm/count-by-alarm-name': ReeferAlarmCountByAlarmName,
  'alarm/count-by-asset': ReeferAlarmCountByAsset,
  'alarm/count-by-reefer-make': ReeferAlarmCountByReeferMake,
  'alarm/count-by-severity': ReeferAlarmCountBySeverity,
  'alarm/details': ReeferAlarmDetails,
  // 'asset/list': AssetList,
  'asset/asset-timeline': AssetTimeline,
  'asset/history-graph': HistoryGraph,
  'asset/in-store-history-graph': InStoreHistoryGraph,
  'asset/reefer-control-history': ReeferControlHistory,
  'asset/reefer-operation-history': ReeferOperationHistory,
  'asset/reefer-operation-detail': ReeferOperationDetail,
  'asset/reefer-history': ReeferHistory,
  'asset/reefer-fridge-data-history': ReeferFridgeDataHistory,
  'asset/door-activities': DoorActivities,
  // could change slug for AlertAcknowledgementByAsset but then we break existing insight configurations
  'asset/alert-action-history': AlertAcknowledgementByAsset,
  'asset/location-history': LocationHistory,
  'asset/route-history': RouteHistoryMap,
  'asset/asset-fleet-check': AssetFleetCheck,
  'asset/monitoring-point': MonitoringPointTemperature,
  'asset/current-engine-hours': CurrentEngineHours,
  'asset/battery-voltage': BatteryVoltage,
  'asset/reefer-run-time-by-asset': ReeferRunTimeByAsset,
  // 'demo/table': DemoTable,
  /* these come from alerts now
  'door/opened-outside-geofence': DoorOpenedOutsideGeofenceDetail,
  'door/opened-outside-geofence-count': DoorOpenedOutsideGeofenceCount,
  */
  // 'temperature/average-monitoring-point': AverageMonitoringPointTemperature,
  'temperature/history': TemperatureHistory,
  'temperature/in-store-history': InStoreTemperatureHistory,
  //alert
  'alert/count-by-alert-name': AlertCountByAlertName,
  'alert/count-by-severity': AlertCountBySeverity,
  'alert/count-by-asset': AlertCountByAsset,
  'alert/alerts-detail': AlertsDetail,
  'alert/alerts-active': AlertsActive,
  'alert/acknowledgement-detail': AlertAcknowledgementDetail,
  'alert/acknowledgement-summary': AlertAcknowledgementSummary,
  'alert/instore-alert-detail': InstoreAlertDetail,
  //utilization
  'utilization/count-by-stationary-asset': StationaryAssetCount,
  'utilization/stationary-assets-detail': StationaryAssetsDetail,
  //fuel
  'fuel/fuel-history': FuelHistory,
  'fuel/reefer-fuel': ReeferFuel,
  'fuel/reefer-fuel-graph': ReeferFuelGraph,
  //speed
  'speed/reefer-speed-graph': ReeferSpeedGraph,
  // report
  'report/speed-exceptions': SpeedException,
  'report/door-events-summary': DoorEventsSummary,
  'report/instore-door-events-summary': InstoreDoorEventsSummary,
  'report/monitoring-point-humidity': MonitoringPointHumidity,
  'report/monitoring-point-temperature': MonitoringPointTemperatureReport,
  'report/trip-activity': TripActivity,
  'report/trip-reefer-summary': TripReeferSummary,
} as const

export type InsightKey = keyof typeof insights
export type InsightMap = typeof insights

export const getInsightDefinition = <K extends InsightKey>(key: K): InsightMap[K] => {
  return insights[key]
}
